// extracted by mini-css-extract-plugin
export var cardContainer = "_nq-0";
export var cardHeader = "_nq-2";
export var collapsedState = "_nq-3";
export var dragHandle = "_nq-5";
export var dragHandleIcon = "_nq-6";
export var dragging = "_nq-1";
export var titleArea = "_nq-4";